<script setup>
/* Filter der Kaderliste nach Altersklasse: einfache Umschaltung Alle / U17 / U19 (keine Mehrfachwahl), im Stil der
   Positionsknöpfe (ListControls.vue). Die Zahlen berücksichtigen Suche, Position und Jahrgang (usePlayers.js).
   Wer die Altersklasse nicht pflegen darf, sieht den Filter nur, wenn überhaupt ein Spieler eine hat (SquadList.vue). */
import { AGE_GROUPS, AGE_GROUP_ALL } from '../domain/ageGroups.js';

defineProps({
  counts: { type: Object, required: true },
});
const value = defineModel({ type: String, required: true });

const KEYS = [AGE_GROUP_ALL, ...AGE_GROUPS];
</script>

<template>
  <div class="filter-group age-filter" role="group" :aria-label="$t('ageGroup.filterLabel')" data-testid="age-group-filter">
    <button
      v-for="key in KEYS"
      :key="key"
      type="button"
      class="btn ghost small"
      :class="{ active: value === key }"
      :aria-pressed="value === key"
      :data-testid="`age-filter-${key}`"
      @click="value = key"
    >
      {{ key === AGE_GROUP_ALL ? $t('ageGroup.filterAll') : key }}
      ({{ counts[key] || 0 }})
    </button>
  </div>
</template>

<style scoped>
.age-filter {
  flex: 1 0 100%;
}
</style>
